import {Palette} from 'hubbl-shared';
import {memo} from 'react';
import styled from 'styled-components';

interface MobileMenuToggleProps {
  onClick: () => void;
  isOpen: boolean;
}

const ToggleButton = styled.button<{isOpen: boolean}>`
  position: fixed;
  scale: 0.8;
  top: 3px;
  left: 6px;
  z-index: 1000;
  background: ${props => (props.isOpen ? 'transparent' : Palette.white)};
  border: none;
  border-radius: ${props => (props.isOpen ? '0' : '8px')};
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${props =>
    props.isOpen ? 'none' : '0px 4px 12px rgba(0, 0, 0, 0.15)'};
  transition: all 0.3s ease;

  &:hover {
    transform: ${props => (props.isOpen ? 'none' : 'scale(1.05)')};
    box-shadow: ${props =>
      props.isOpen ? 'none' : '0px 6px 16px rgba(0, 0, 0, 0.2)'};
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

const HamburgerIcon = styled.div<{isOpen: boolean}>`
  width: 20px;
  height: 16px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.3s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${props =>
      props.isOpen ? Palette.almostBlack : Palette.almostBlack};
    border-radius: 2px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.3s ease-in-out;

    &:nth-child(1) {
      top: 0px;
      transform: ${props =>
        props.isOpen
          ? 'rotate(45deg) translate(5px, 5px)'
          : 'rotate(0deg) translate(0, 0)'};
    }

    &:nth-child(2) {
      top: 7px;
      opacity: ${props => (props.isOpen ? '0' : '1')};
      transform: ${props => (props.isOpen ? 'scale(0)' : 'scale(1)')};
    }

    &:nth-child(3) {
      top: 14px;
      transform: ${props =>
        props.isOpen
          ? 'rotate(-45deg) translate(5px, -5px)'
          : 'rotate(0deg) translate(0, 0)'};
    }
  }
`;

export const MobileMenuToggle = memo(
  ({onClick, isOpen}: MobileMenuToggleProps) => {
    return (
      <ToggleButton
        onClick={onClick}
        isOpen={isOpen}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}>
        <HamburgerIcon isOpen={isOpen}>
          <span></span>
          <span></span>
          <span></span>
        </HamburgerIcon>
      </ToggleButton>
    );
  },
);
